import { Pipe, PipeTransform, inject } from "@angular/core";
import { MODULES } from "src/app/core/modules";
import { ModuleService } from "src/app/services/feature-access-control/module.service";

@Pipe({
  name: "canBeActivated",
  standalone: false
})
export class CanBeActivatedPipe implements PipeTransform {
  private readonly mooduleService = inject(ModuleService);

  transform(value: string) {
    return this.mooduleService.canBeActivatedSync(<MODULES>value);
  }
}
